var _path, _circle, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCrossed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5527 13.2686C22.3432 15.1498 21.3318 16.7921 19.8613 17.8457C19.8718 17.8509 19.8829 17.8532 19.8935 17.8584C21.0813 18.357 22.1611 19.0797 23.0722 19.9854C23.9859 20.8883 24.7141 21.959 25.2158 23.1377C25.7103 24.2957 25.9733 25.5224 25.9999 26.7832C26.0007 26.8114 25.9957 26.84 25.9853 26.8662C25.9749 26.8924 25.9592 26.9164 25.9394 26.9365C25.9196 26.9566 25.8961 26.9725 25.8701 26.9834C25.8439 26.9943 25.8154 27 25.787 27H24.1913C24.0744 27 23.9811 26.91 23.9785 26.7939C23.9252 24.7574 23.1009 22.85 21.6435 21.4043C20.303 20.0746 18.5714 19.278 16.705 19.1172L22.5527 13.2686ZM6.71771 27H6.21283C6.18444 27 6.15599 26.9943 6.12982 26.9834C6.10382 26.9725 6.08021 26.9566 6.06049 26.9365C6.04068 26.9164 6.02496 26.8924 6.01459 26.8662C6.00421 26.84 5.99923 26.8114 5.99994 26.7832C6.00307 26.6231 6.01042 26.4632 6.02142 26.3037L6.71771 27ZM15.9999 6C18.7896 6 21.1713 7.71772 22.1357 10.1445L20.5068 11.7734C20.3492 10.8549 19.9125 10.0078 19.2343 9.33496C18.37 8.47755 17.2207 8.00488 15.9999 8.00488C14.7792 8.0049 13.6299 8.47756 12.7656 9.33496C11.9014 10.1923 11.4257 11.3322 11.4257 12.543C11.4258 13.7538 11.9013 14.8936 12.7656 15.751C13.4528 16.4327 14.3206 16.8695 15.2607 17.0205L12.2939 19.9873C11.589 20.3549 10.9359 20.8295 10.3564 21.4043C9.76225 21.9937 9.27471 22.6606 8.90033 23.3809L6.02533 26.2559C6.10457 25.1843 6.36079 24.1318 6.7851 23.1406C7.28776 21.9623 8.01565 20.8911 8.92865 19.9873C9.8461 19.0747 10.9151 18.3599 12.1064 17.8613C12.117 17.8561 12.128 17.8529 12.1386 17.8477C10.4818 16.6579 9.40432 14.7246 9.40424 12.543C9.40424 8.92867 12.3564 6.00004 15.9999 6Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14.5,
    stroke: "currentColor",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 25.2817,
    width: 30.0969,
    height: 3,
    transform: "rotate(-45 4 25.2817)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCrossed);
export default __webpack_public_path__ + "static/media/userCrossed.e58353f3b1345ffa820601ecd9be7f71.svg";
export { ForwardRef as ReactComponent };